import React from 'react';
import ReactDOM from 'react-dom';
import styles from './Tooltip.module.css';

class Tooltip extends React.Component {
  constructor(props) {
    super(props);
    this.state = { visible: false, pos: { top: 0, left: 0 } };
    this.triggerRef = React.createRef();
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  }

  show() {
    if (!this.triggerRef.current) return;
    const rect = this.triggerRef.current.getBoundingClientRect();
    const { placement = 'top' } = this.props;
    let top, left;
    if (placement === 'top')    { top = rect.top + window.scrollY - 6; left = rect.left + rect.width / 2 + window.scrollX; }
    if (placement === 'bottom') { top = rect.bottom + window.scrollY + 6; left = rect.left + rect.width / 2 + window.scrollX; }
    if (placement === 'left')   { top = rect.top + rect.height / 2 + window.scrollY; left = rect.left + window.scrollX - 6; }
    if (placement === 'right')  { top = rect.top + rect.height / 2 + window.scrollY; left = rect.right + window.scrollX + 6; }
    this.setState({ visible: true, pos: { top, left, placement } });
  }

  hide() { this.setState({ visible: false }); }

  render() {
    const { children, content, placement = 'top' } = this.props;
    const { visible, pos } = this.state;

    const tip = visible ? ReactDOM.createPortal(
      <div
        className={[styles.tooltip, styles[placement]].join(' ')}
        style={{ top: pos.top, left: pos.left }}
      >
        {content}
      </div>,
      document.body
    ) : null;

    return (
      <>
        <span
          ref={this.triggerRef}
          onMouseEnter={this.show}
          onMouseLeave={this.hide}
          style={{ display: 'inline-flex' }}
        >
          {children}
        </span>
        {tip}
      </>
    );
  }
}

export default Tooltip;
